module.exports = __webpack_public_path__ + "img/200.2feec139.svg";